import * as d from "@fragaria/address-formatter";
import { omitUndefinedAndNull } from "@repo/utils";

export type Address = Partial<Record<d.AttentionInputType | d.PrimaryInputTypes, string>>;

export function formatAddress(input: Address, options?: d.CommonOptions & { output?: "string" }): string;
export function formatAddress(input: Address, options: d.CommonOptions & { output: "array" }): string[];
export function formatAddress(input: Address, options?: unknown): unknown {
    const dd = d as any;
    input = omitUndefinedAndNull(input);
    return (dd.default?.format ?? dd.format)(input, options) as never;
}

export function combineStreetAndNumber(
    street: string | null | undefined,
    houseNumber: string | null | undefined,
    countryCode: string | null | undefined,
) {
    if (!street) {
        return "";
    }
    if (!houseNumber) {
        return street;
    }

    const lines = formatAddress(
        { road: street, houseNumber, countryCode: countryCode ?? "DE" },
        { output: "array", fallbackCountryCode: "DE" },
    );

    const streetLine = lines.find(line => line.trim().length > 0);
    return streetLine?.trim() ?? [street, houseNumber].filter(Boolean).join(" ");
}
